import { Component, Input, OnInit } from "@angular/core";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { UnleashFeatureFlagService } from "gematik-shared";

@Component({
  selector: "side-navigation-item",
  styleUrls: ["side-navigation-item.component.scss"],
  animations: [
    trigger("rotatedState", [
      state("default", style({ transform: "rotate(0)" })),
      state("rotated", style({ transform: "rotate(90deg)" })),
      transition("rotated => default", animate("300ms ease-out")),
      transition("default => rotated", animate("300ms ease-in")),
    ]),
    trigger("openClose", [
      state("true", style({ height: "*", opacity: 1 })),
      state("false", style({ height: "0px", opacity: 0 })),
      transition("false <=> true", animate(300)),
    ]),
  ],
  template: `<ul>
    <li>
      <div class="d-flex align-items-center">
        <mat-icon
          class="nav-icons"
          style="color: var(--gematik-blue)"
          svgIcon="{{ treeContent.icon }}"
          [routerLink]="treeContent.route"
          [routerLinkActive]="'active-icon'"
        ></mat-icon>
        <a
          data-testid="parentLink"
          (click)="toggleTreeElement()"
          [routerLink]="treeContent.route"
          class="gem-link-blue"
          [routerLinkActive]="'active'"
        >
          <span *ngIf="isExpanded" class="nav-main-item-label">{{
            treeContent.rootLabel | translate
          }}</span>
        </a>
        <gem-help-icon
          *ngIf="isExpanded && helpTooltipsEnabled"
          class="d-flex ms-1"
          [tooltip]="treeContent.tooltip | translate"
        ></gem-help-icon>
      </div>
      <ul
        *ngIf="isExpanded"
        [@openClose]="treeElementOpened ? true : false"
        class="open-close-container"
      >
        <li *ngFor="let link of treeContent.links" class="nav-line-item d-flex align-items-center">
          <a
            *ngIf="link.route"
            class="flex-grow-1"
            [routerLink]="link.route" [routerLinkActive]="'active'">
            <div class="d-flex">
              <div class="flex-grow-1 gem-color-blue me-3">{{ link.label | translate }}</div>
              <div
                *ngIf="link.badge && (link.badge | async) >= 0"
                class="gem-badge"
                [class.gem-color-dark-grey]="(link.badge | async) === 0"
              >
                {{ link.badge | async }}
              </div>
            </div>
          </a>
          <gem-help-icon
            *ngIf="helpTooltipsEnabled"
            class="d-flex ms-1"
            [class.nav-help-icon]="link.badge"
            [tooltip]="link.tooltip | translate"
          ></gem-help-icon>
        </li>
      </ul>
    </li>
  </ul>`,
  standalone: false,
})
export class SideNavigationItemComponent implements OnInit {
  @Input() treeContent: {
    rootLabel: string;
    tooltip: string;
    icon: string;
    route: string;
    links: [{ label: string; tooltip: string; route: string; badge: string }];
    treeElementOpened: boolean;
  };
  @Input() isExpanded: boolean;

  treeElementOpened: boolean;
  state = "rotated";

  constructor(private readonly featureFlags: UnleashFeatureFlagService) {}

  get helpTooltipsEnabled(): boolean {
    return this.featureFlags.isEnabled("uwl.frontend.menu.help-tooltips");
  }

  ngOnInit(): void {
    this.treeElementOpened = this.treeContent.treeElementOpened;
  }

  toggleTreeElement(): void {
    this.treeElementOpened = !this.treeElementOpened;
    if (this.treeElementOpened) {
      this.state = "rotated";
    } else {
      this.state = "default";
    }
  }
}
